import { api } from './api';

export const videosApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getVideosList: builder.query({
      query: (params = {}) => {
        const { page = 1, limit = 10, search, sortBy, sortOrder, status } = params;
        const queryParams = {
          page,
          limit,
          ...(search && { search }),
          ...(sortBy && { sortBy }),
          ...(sortOrder && { sortOrder }),
          // Always send status so cache key changes when filter changes (empty = "all")
          status: status !== undefined && status !== null && status !== '' ? String(status) : '',
        };
        return { url: '/admin/videos', params: queryParams };
      },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Video', id })),
              { type: 'Video', id: 'LIST' },
            ]
          : [{ type: 'Video', id: 'LIST' }],
    }),
    deleteVideo: builder.mutation({
      query: (id) => ({
        url: `/admin/videos/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Video', id },
        { type: 'Video', id: 'LIST' },
      ],
    }),
    deleteVideosBulk: builder.mutation({
      query: (ids) => ({
        url: '/admin/videos',
        method: 'DELETE',
        body: { ids },
      }),
      invalidatesTags: [{ type: 'Video', id: 'LIST' }],
    }),
    setFeaturedVideos: builder.mutation({
      query: ({ ids, featured }) => ({
        url: '/admin/videos/set-featured',
        method: 'PATCH',
        body: { ids, featured },
      }),
      invalidatesTags: (result, error, { ids }) => [
        ...(ids || []).map((id) => ({ type: 'Video', id })),
        { type: 'Video', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetVideosListQuery,
  useDeleteVideoMutation,
  useDeleteVideosBulkMutation,
  useSetFeaturedVideosMutation,
} = videosApi;
